import {converter, formatHex, wcagContrast} from 'culori'

export const MIN_TEXT_CONTRAST = 4.5

const LIGHTNESS_STEP = 0.02
const DARK_BACKGROUND_LIGHTNESS_LIMIT = 0.5

const toOkLch = converter('oklch')

function getLowestContrast(color: string, backgroundColors: string[]): number {
  return Math.min(...backgroundColors.map(backgroundColor => wcagContrast(color, backgroundColor)))
}

export function getReadableTextColor(color: string, backgroundColors: string[], minContrast = MIN_TEXT_CONTRAST): string {
  const textColor = toOkLch(color)
  const backgrounds = backgroundColors.map(backgroundColor => toOkLch(backgroundColor))
  if(!textColor || !backgrounds.length || backgrounds.some(background => !background) || getLowestContrast(color, backgroundColors) >= minContrast) {
    return color
  }
  const direction = backgrounds.every(background => background.l < DARK_BACKGROUND_LIGHTNESS_LIMIT) ? 1 : -1
  let lightness = textColor.l
  while(lightness > 0 && lightness < 1) {
    lightness = Math.min(1, Math.max(0, lightness + direction * LIGHTNESS_STEP))
    const candidate = formatHex({
      ...textColor,
      l: lightness,
    })
    if(getLowestContrast(candidate, backgroundColors) >= minContrast) {
      return candidate
    }
  }
  return formatHex({
    ...textColor,
    l: direction > 0 ? 1 : 0,
  })
}
